import axios from '../../utils/axios'

// 基础库-列表
export function basic_warehouse_index_index(data) {
    return axios({
        url: '/admin/basic_warehouse/index/index', method: 'POST', data: data
    })
}

// 基础库-列表类目选项
export function basic_warehouse_index_get_finish_category_lists(data) {
    return axios({
        url: '/admin/basic_warehouse/index/get_finish_category_lists', method: 'POST', data: data
    })
}


// 根类目-列表
export function basic_warehouse_root_category_index(data) {
    return axios({
        url: '/admin/basic_warehouse/root_category/index', method: 'POST', data: data
    })
}

// 根类目-更新指定类目的Asin排名
export function basic_warehouse_root_category_update_category_status(data) {
    return axios({
        url: '/admin/basic_warehouse/root_category/update_category_status', method: 'POST', data: data
    })
}

// 根类目-更新指定类目的Asin排名的类目选项
export function basic_warehouse_root_category_lists(data) {
    return axios({
        url: '/admin/basic_warehouse/root_category/lists', method: 'POST', data: data
    })
}

// 分库管理-管理员分库列表
export function branch_warehouse_manager_index(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/index', method: 'POST', data: data
    })
}

// 分库管理-管理员添加分库
export function branch_warehouse_manager_add(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/add', method: 'POST', data: data
    })
}

// 分库管理-管理员删除分库
export function branch_warehouse_manager_delete(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/delete', method: 'POST', data: data
    })
}

// 分库管理-管理员执行1688链接更新
export function branch_warehouse_manager_carry_alibaba_link(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/carry_alibaba_link', method: 'POST', data: data
    })
}

// 分库管理-管理员获取采购人员
export function branch_warehouse_manager_get_developers(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/get_developers', method: 'POST', data: data
    })
}

// 分库管理-管理员分配采购人员
export function branch_warehouse_manager_assign_developer(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/assign_developer', method: 'POST', data: data
    })
}

// 分库管理-管理员分库列表对应类目
export function branch_warehouse_manager_get_category_list(data) {
    return axios({
        url: '/admin/branch_warehouse/manager/get_category_list', method: 'POST', data: data
    })
}

// 分库详情-列表
export function branch_warehouse_details_index(data) {
    return axios({
        url: '/admin/branch_warehouse/details/index', method: 'POST', data: data
    })
}

// 分库详情的类目选项
export function branch_warehouse_details_get_detail_category(data) {
    return axios({
        url: '/admin/branch_warehouse/details/get_detail_category', method: 'POST', data: data
    })
}

// 分库管理-用户分库列表
export function branch_warehouse_user_index(data) {
    return axios({
        url: '/admin/branch_warehouse/user/index', method: 'POST', data: data
    })
}

// 更新1688连接
export function branch_warehouse_line_update_link(data) {
    return axios({
        url: '/admin/branch_warehouse/link/update_link', method: 'POST', data: data
    })
}

// 更新1688连接
export function branch_warehouse_line_get_update_status(data) {
    return axios({
        url: '/admin/branch_warehouse/link/get_update_status', method: 'POST', data: data
    })
}

// 成本分析列表
export function cost_analysis_index_index(data) {
    return axios({
        url: '/admin/cost_analysis/index/index', method: 'POST', data: data
    })
}

// 分配给我
export function cost_analysis_index_assign_to_me(data) {
    return axios({
        url: '/admin/cost_analysis/index/assign_to_me', method: 'POST', data: data
    })
}

// 成本分析-我的选品列表
export function cost_analysis_personal_analysis_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/analysis_list', method: 'POST', data: data
    })
}

// 成本分析-取消分配
export function cost_analysis_personal_cancel_assign(data) {
    return axios({
        url: '/admin/cost_analysis/personal/cancel_assign', method: 'POST', data: data
    })
}

// 成本分析-操作
export function cost_analysis_personal_personal_operation(data) {
    return axios({
        url: '/admin/cost_analysis/personal/personal_operation', method: 'POST', data: data
    })
}

// 成本分析-可选1688链接列表
export function cost_analysis_personal_get_ali_result_lists(data) {
    return axios({
        url: '/admin/cost_analysis/personal/get_ali_result_lists', method: 'POST', data: data
    })
}

export function low_price_mall_developer_get_ali_result_lists(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/get_ali_result_lists', method: 'POST', data: data
    })
}

// 成本分析-采购
export function cost_analysis_personal_add_to_purchase_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/add_to_purchase_list', method: 'POST', data: data
    })
}

// 成本分析-采购
export function cost_analysis_personal_purchase_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/purchase_list', method: 'POST', data: data
    })
}

// 成本分析-采购回退
export function cost_analysis_personal_return_from_purchase_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/return_from_purchase_list', method: 'POST', data: data
    })
}

// 成本分析-采购完成
export function cost_analysis_personal_finish_purchase(data) {
    return axios({
        url: '/admin/cost_analysis/personal/finish_purchase', method: 'POST', data: data
    })
}

// 成本分析-采购完成列表
export function cost_analysis_personal_purchase_finish_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/purchase_finish_list', method: 'POST', data: data
    })
}

// 运营选品-未分配列表
export function operation_index_undistributed_list(data) {
    return axios({
        url: '/admin/operation/index/undistributed_list', method: 'POST', data: data
    })
}

// 运营选品-分配给自己
export function operation_index_assign_to_me(data) {
    return axios({
        url: '/admin/operation/index/assign_to_me', method: 'POST', data: data
    })
}

// 运营选品-我的选品
export function operation_index_assigned_list(data) {
    return axios({
        url: '/admin/operation/index/assigned_list', method: 'POST', data: data
    })
}

// 运营选品-取消分配
export function operation_index_cancel_assign(data) {
    return axios({
        url: '/admin/operation/index/cancel_assign', method: 'POST', data: data
    })
}

// 成本分析-重置
export function cost_analysis_personal_reset(data) {
    return axios({
        url: '/admin/cost_analysis/personal/reset', method: 'POST', data: data
    })
}

// 成本分析-修改数据
export function cost_analysis_personal_update_field(data) {
    return axios({
        url: '/admin/cost_analysis/personal/update_field', method: 'POST', data: data
    })
}

// 未分配自建选品-列表
export function cost_analysis_personal_undistributed_self_build_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/undistributed_self_build_list', method: 'POST', data: data
    })
}

// 成本分析-采购完成回退
export function cost_analysis_personal_return_from_purchase_finish_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/return_from_purchase_finish_list', method: 'POST', data: data
    })
}

// 未分配自建选品-分配给自己
export function cost_analysis_personal_assign_undistributed_self_build_to_me(data) {
    return axios({
        url: '/admin/cost_analysis/personal/assign_undistributed_self_build_to_me', method: 'POST', data: data
    })
}

// 成本分析-自建成本分析
export function cost_analysis_selfbuild_create(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/create', method: 'POST', data: data
    })
}

// 成本分析-自建成本分析对应类目
export function cost_analysis_selfbuild_category_for_create(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/category_for_create', method: 'POST', data: data
    })
}

// 成本分析-删除自建未加购选品
export function cost_analysis_selfbuild_deleted(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/deleted', method: 'POST', data: data
    })
}

// 成本分析-自建未分配列表
export function manager_cost_analysis_manager_undistributed_self_build_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_undistributed_self_build_list', method: 'POST', data: data
    })
}

// 成本分析-批量分配自建未分配列表
export function manager_cost_analysis_manager_batch_distribution(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_batch_distribution', method: 'POST', data: data
    })
}

// 管理员管理-获取采购人员
export function manager_index_get_developer_list(data) {
    return axios({
        url: '/admin/manager/index/get_developer_list', method: 'POST', data: data
    })
}

// 成本分析-采购人员选品列表
export function manager_cost_analysis_manager_analysis_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_analysis_list', method: 'POST', data: data
    })
}

// 成本分析-采购人员加购中列表
export function manager_cost_analysis_manager_purchase_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_purchase_list', method: 'POST', data: data
    })
}

// 成本分析-采购人员加购完成列表
export function manager_cost_analysis_manager_purchase_finish_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_purchase_finish_list', method: 'POST', data: data
    })
}

// 成本分析-采购人员加购中列表导出
export function manager_cost_analysis_export_manager_purchase_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/export_manager_purchase_list', method: 'POST', data: data
    })
}

// 管理员管理-获取运营人员
export function manager_index_get_operator_list(data) {
    return axios({
        url: '/admin/manager/index/get_operator_list', method: 'POST', data: data
    })
}

// 管理员-创建分库列表
export function manager_build_selection_task_list(data) {
    return axios({
        url: '/admin/manager/build_selection/task_list', method: 'POST', data: data
    })
}

// 管理员-创建分库详情
export function manager_build_selection_task_list_detail(data) {
    return axios({
        url: '/admin/manager/build_selection/task_list_detail', method: 'POST', data: data
    })
}

// 管理员-添加分库
export function manager_build_selection_add(data) {
    return axios({
        url: '/admin/manager/build_selection/add', method: 'POST', data: data
    })
}

// 管理员功能-获取类目信息
export function manager_index_get_category_message(data) {
    return axios({
        url: '/admin/manager/index/get_category_message', method: 'POST', data: data
    })
}

// 运营选品导出
export function operation_index_export(data) {
    return axios({
        url: '/admin/operation/index/export', method: 'POST', data: data
    })
}

// 运营选品导出
export function export_operating_asin_cost_analysis(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/export_operating_asin_cost_analysis', method: 'POST', data: data
    })
}

// 管理员选库-采购员更新中列表
export function cost_analysis_assigned_selection_assigned_updating_list(data) {
    return axios({
        url: '/admin/cost_analysis/assigned_selection/assigned_updating_list', method: 'POST', data: data
    })
}

// 管理员-分库分配采购人员
export function manager_build_selection_assign_developer(data) {
    return axios({
        url: '/admin/manager/build_selection/assign_developer', method: 'POST', data: data
    })
}
// 管理员-分库分配采购人员
export function asin_list_bind_asin_teambition_task(data) {
    return axios({
        url: '/admin/seed_word/asin_list/bind_asin_teambition_task', method: 'POST', data: data
    })
}

// 管理员功能-获取类目列表
export function manager_index_get_category_list(data) {
    return axios({
        url: '/admin/manager/index/get_category_list', method: 'POST', data: data
    })
}

// 类目映射-列表
export function category_category_mapping_index(data) {
    return axios({
        url: '/admin/category/category_mapping/index', method: 'POST', data: data
    })
}

// 类目映射-更新
export function category_category_mapping_update(data) {
    return axios({
        url: '/admin/category/category_mapping/update', method: 'POST', data: data
    })
}

// 类目映射-新增
export function category_category_mapping_add(data) {
    return axios({
        url: '/admin/category/category_mapping/add', method: 'POST', data: data
    })
}

// 类目映射-删除
export function category_category_mapping_deleted(data) {
    return axios({
        url: '/admin/category/category_mapping/deleted', method: 'POST', data: data
    })
}

// 管理员功能-获取基础配置数据
export function manager_index_get_cost_control_message(data) {
    return axios({
        url: '/admin/manager/index/get_cost_control_message', method: 'POST', data: data
    })
}

// 管理员功能-修改基础配置数据
export function manager_index_update_cost_control_message(data) {
    return axios({
        url: '/admin/manager/index/update_cost_control_message', method: 'POST', data: data
    })
}

// 成本分析-自建成本分析(自动填充)
export function cost_analysis_selfbuild_autofill(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/autofill', method: 'POST', data: data
    })
}

// 管理员-删除分库
export function manager_build_selection_deleted(data) {
    return axios({
        url: '/admin/manager/build_selection/deleted', method: 'POST', data: data
    })
}

// 仓储费计算-单个计算
export function extra_delivery_charge_calculator_calculate(data) {
    return axios({
        url: '/admin/extra/delivery_charge_calculator/calculate', method: 'POST', data: data
    })
}

// 配送费计算-批量计算
export function extra_delivery_charge_calculator_batch_calculate(data) {
    return axios({
        url: '/admin/extra/delivery_charge_calculator/batch_calculate', method: 'POST', data: data
    })
}

// 管理员-类目统计
export function manager_statistics_statistics_category(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_category', method: 'POST', data: data
    })
}

// 选品统计
export function manager_statistics_statistics_developer(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_developer', method: 'POST', data: data
    })
}

// 运营选品-设为运营中
export function operation_index_update_operation_status_to_running(data) {
    return axios({
        url: '/admin/operation/index/update_operation_status_to_running', method: 'POST', data: data
    })
}

// 运营选品-设为不再运营
export function operation_index_update_operation_status_to_fail(data) {
    return axios({
        url: '/admin/operation/index/update_operation_status_to_fail', method: 'POST', data: data
    })
}

// 管理员分库统计
export function manager_statistics_statistics_manager_selection(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_manager_selection', method: 'POST', data: data
    })
}

// 运营统计
export function manager_statistics_statistics_operator(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_operator', method: 'POST', data: data
    })
}

// 链接制作统计
export function manager_statistics_statistics_producer(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_producer', method: 'POST', data: data
    })
}

// 个人运营统计
export function operation_index_personal_statistics_operator(data) {
    return axios({
        url: '/admin/operation/index/personal_statistics_operator', method: 'POST', data: data
    })
}

// 管理员列表
export function master_index_manager_lists(data) {
    return axios({
        url: '/admin/master/index/manager_lists', method: 'POST', data: data
    })
}

// 指定管理员成本分析详情
export function master_index_manager_cost_analysis_details(data) {
    return axios({
        url: '/admin/master/index/manager_cost_analysis_details', method: 'POST', data: data
    })
}

// 个人选品统计
export function cost_analysis_statistics_statistics_developer(data) {
    return axios({
        url: '/admin/cost_analysis/statistics/statistics_developer', method: 'POST', data: data
    })
}

// 个人管理员分库统计
export function cost_analysis_statistics_statistics_manager_selection(data) {
    return axios({
        url: '/admin/cost_analysis/statistics/statistics_manager_selection', method: 'POST', data: data
    })
}

// 获取已有管理员分库列表
export function manager_build_selection_get_own_selection_list(data) {
    return axios({
        url: '/admin/manager/build_selection/get_own_selection_list', method: 'POST', data: data
    })
}

// 分库数据迁移
export function manager_build_selection_migrate_datas(data) {
    return axios({
        url: '/admin/manager/build_selection/migrate_datas', method: 'POST', data: data
    })
}

// 成本分析-采购完成不符利润列表
export function manager_cost_analysis_manager_operational_and_profitable_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_operational_and_profitable_list', method: 'POST', data: data
    })
}

// 成本分析-一审审核
export function manager_cost_analysis_audit_review_first(data) {
    return axios({
        url: '/admin/manager/cost_analysis/audit_review_first', method: 'POST', data: data
    })
}

// 成本分析-审核详情列表
export function manager_cost_analysis_audit_review_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/audit_review_list', method: 'POST', data: data
    })
}

// 一审列表
export function cost_analysis_personal_audit_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/audit_list', method: 'POST', data: data
    })
}

// 管理员-kpi周统计
export function manager_statistics_statistics_kpi_week(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_kpi_week', method: 'POST', data: data
    })
}

// 管理员-kpi月统计
export function manager_statistics_statistics_kpi_month(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_kpi_month', method: 'POST', data: data
    })
}

// 管理员功能-获取成本分析详细数据
export function manager_index_get_cost_analysis_detail_datas(data) {
    return axios({
        url: '/admin/manager/index/get_cost_analysis_detail_datas', method: 'POST', data: data
    })
}

export function manager_index_get_single_cost_analysis_detail_data(data) {
    return axios({
        url: '/admin/manager/index/get_single_cost_analysis_detail_data', method: 'POST', data: data
    })
}

export function manager_cost_analysis_audit_review_first_return(data) {
    return axios({
        url: '/admin/manager/cost_analysis/audit_review_first_return', method: 'POST', data: data
    })
}

// 参考库-参考库列表
export function reference_index_reference_list(data) {
    return axios({
        url: '/admin/reference/index/reference_list', method: 'POST', data: data
    })
}

// 参考库-参考库类目列表
export function reference_index_get_curl_category_message(data) {
    return axios({
        url: '/admin/reference/index/get_curl_category_message', method: 'POST', data: data
    })
}

// 参考库-判断是否已经做过此asin产品
export function reference_index_check_asin_product_exist(data) {
    return axios({
        url: '/admin/reference/index/check_asin_product_exist', method: 'POST', data: data
    })
}

// 参考库-搜索1688相似连接
export function reference_index_search_ali_result(data) {
    return axios({
        url: '/admin/reference/index/search_ali_result', method: 'POST', data: data
    })
}

// 参考库-创建成本分析
export function reference_index_create(data) {
    return axios({
        url: '/admin/reference/index/create', method: 'POST', data: data
    })
}

// 运营选品 - 运营asin列表
export function operation_index_get_operator_asin_list(data) {
    return axios({
        url: '/admin/operation/index/get_operator_asin_list', method: 'POST', data: data
    })
}

// 运营选品 - 添加运营asin
export function operation_index_add_operator_asin(data) {
    return axios({
        url: '/admin/operation/index/add_operator_asin', method: 'POST', data: data
    })
}

// 运营选品 - 修改运营asin
export function operation_index_update_operator_asin(data) {
    return axios({
        url: '/admin/operation/index/update_operator_asin', method: 'POST', data: data
    })
}

// 运营选品 - 删除运营asin
export function operation_index_delete_operator_asin(data) {
    return axios({
        url: '/admin/operation/index/delete_operator_asin', method: 'POST', data: data
    })
}

// 运营选品 - 加入我的运营
export function operation_index_transfer_running_to_me(data) {
    return axios({
        url: '/admin/operation/index/transfer_running_to_me', method: 'POST', data: data
    })
}

// 成本分析-选品列表(转移)
export function cost_analysis_transfer_transfer_analysis_list(data) {
    return axios({
        url: '/admin/cost_analysis/transfer/transfer_analysis_list', method: 'POST', data: data
    })
}

// 成本分析-采购中列表(转移)
export function cost_analysis_personal_transfer_purchase_list(data) {
    return axios({
        url: '/admin/cost_analysis/transfer/transfer_purchase_list', method: 'POST', data: data
    })
}

// 成本分析-删除（转移）
export function cost_analysis_transfer_deleted(data) {
    return axios({
        url: '/admin/cost_analysis/transfer/deleted', method: 'POST', data: data
    })
}

// 管理员 - 选中人员的选品列表
export function manager_manager_transfer_manager_transfer_analysis_list(data) {
    return axios({
        url: '/admin/manager/manager_transfer/manager_transfer_analysis_list', method: 'POST', data: data
    })
}

// 管理员 - 转移选品数据
export function manager_manager_transfer_transfer_analysis(data) {
    return axios({
        url: '/admin/manager/manager_transfer/transfer_analysis', method: 'POST', data: data
    })
}

// 管理员 - 选中人员的采购中列表
export function manager_manager_manager_transfer_purchase_list(data) {
    return axios({
        url: '/admin/manager/manager_transfer/manager_transfer_purchase_list', method: 'POST', data: data
    })
}

// 管理员 - 选中人员的采购中列表
export function manager_manager_transfer_transfer_purchase(data) {
    return axios({
        url: '/admin/manager/manager_transfer/transfer_purchase', method: 'POST', data: data
    })
}

// 管理员-释放运营我的选品数据
export function manager_manager_transfer_transfer_release_assigned(data) {
    return axios({
        url: '/admin/manager/manager_transfer/transfer_release_assigned', method: 'POST', data: data
    })
}

// 管理员-选中人员的运营中列表
export function manager_manager_transfer_manager_transfer_assigned_running_list(data) {
    return axios({
        url: '/admin/manager/manager_transfer/manager_transfer_assigned_running_list', method: 'POST', data: data
    })
}

// 管理员-转移运营中数据
export function manager_manager_transfer_transfer_assigned_running(data) {
    return axios({
        url: '/admin/manager/manager_transfer/transfer_assigned_running', method: 'POST', data: data
    })
}

// 管理员-选中人员的运营选品列表
export function manager_manager_transfer_manager_transfer_assigned_list(data) {
    return axios({
        url: '/admin/manager/manager_transfer/manager_transfer_assigned_list', method: 'POST', data: data
    })
}

// 运营 - 采购人员列表
export function operation_index_get_developer_list(data) {
    return axios({
        url: '/admin/manager/index/get_developer_list', method: 'POST', data: data
    })
}

// 用户组长权限-指定组员选品列表
export function group_index_get_purchase_list(data) {
    return axios({
        url: '/admin/group/index/get_purchase_list', method: 'POST', data: data
    })
}

// 用户组长权限-指定组员运营列表
export function group_index_get_operation_list(data) {
    return axios({
        url: '/admin/group/index/get_operation_list', method: 'POST', data: data
    })
}

// 管理员组长权限-获取所有成员
export function group_index_get_all_member(data) {
    return axios({
        url: '/admin/group/index/get_all_member', method: 'POST', data: data
    })
}

// 管理员组长权限-获取所有成员
export function group_manager_get_all_member(data) {
    return axios({
        url: '/admin/group/manager/get_all_member', method: 'POST', data: data
    })
}

// 管理员组长权限-获取组员人员列表
export function group_manager_get_member_list(data) {
    return axios({
        url: '/admin/group/manager/get_member_list', method: 'POST', data: data
    })
}

// 管理员组长权限-更新组员
export function group_manager_update_member(data) {
    return axios({
        url: '/admin/group/manager/update_member', method: 'POST', data: data
    })
}

// 管理员组长权限-更新组员
export function group_manager_get_leader_list(data) {
    return axios({
        url: '/admin/group/manager/get_leader_list', method: 'POST', data: data
    })
}

// 获取我的所有组员
export function group_index_get_personal_member(data) {
    return axios({
        url: '/admin/group/index/get_personal_member', method: 'POST', data: data
    })
}


// 物流操作-上传文件列表
export function logistics_index_index(data) {
    return axios({
        url: '/admin/logistics/index/index', method: 'POST', data: data
    })
}

// 物流操作-文件详情
export function logistics_index_detail(data) {
    return axios({
        url: '/admin/logistics/index/detail', method: 'POST', data: data
    })
}

// 物流操作-上传
export function logistics_index_upload(data) {
    return axios({
        url: '/admin/logistics/index/upload', method: 'POST', data: data
    })
}

// 已处理Asin查询-查询
export function extra_dealt_asin_query_query(data) {
    return axios({
        url: '/admin/extra/dealt_asin_query/query', method: 'POST', data: data
    })
}


// 物流地址-分页列表
export function logistics_address_index(data) {
    return axios({
        url: '/admin/logistics/address/index', method: 'POST', data: data
    })
}

// 物流地址-新增
export function logistics_address_add(data) {
    return axios({
        url: '/admin/logistics/address/add', method: 'POST', data: data
    })
}

// 物流地址-编辑
export function logistics_address_edit(data) {
    return axios({
        url: '/admin/logistics/address/edit', method: 'POST', data: data
    })
}

// 物流地址-删除
export function logistics_address_deleted(data) {
    return axios({
        url: '/admin/logistics/address/deleted', method: 'POST', data: data
    })
}


// 物流Asin-分页列表
export function logistics_asin_index(data) {
    return axios({
        url: '/admin/logistics/asin/index', method: 'POST', data: data
    })
}

// 物流Asin-新增
export function logistics_asin_add(data) {
    return axios({
        url: '/admin/logistics/asin/add', method: 'POST', data: data
    })
}

// 物流Asin-编辑
export function logistics_asin_edit(data) {
    return axios({
        url: '/admin/logistics/asin/edit', method: 'POST', data: data
    })
}

// 物流Asin-删除
export function logistics_asin_deleted(data) {
    return axios({
        url: '/admin/logistics/asin/deleted', method: 'POST', data: data
    })
}


// Asin负责人对应-列表
export function logistics_asin_supervisor_index(data) {
    return axios({
        url: '/admin/logistics/asin_supervisor/index', method: 'POST', data: data
    })
}

// Asin负责人对应-上传
export function logistics_asin_supervisor_upload(data) {
    return axios({
        url: '/admin/logistics/asin_supervisor/upload', method: 'POST', data: data
    })
}

// 刷新图片
export function logistics_asin_fresh_img_url(data) {
    return axios({
        url: '/admin/logistics/asin/fresh_img_url', method: 'POST', data: data
    })
}


// 物流发票-列表
export function logistics_invoice_index(data) {
    return axios({
        url: '/admin/logistics/invoice/index', method: 'POST', data: data
    })
}

// 物流发票-生成
export function logistics_invoice_create(data) {
    return axios({
        url: '/admin/logistics/invoice/create', method: 'POST', data: data
    })
}

// 物流发票-修改
export function logistics_invoice_update_field(data) {
    return axios({
        url: '/admin/logistics/invoice/update_field', method: 'POST', data: data
    })
}

// 物流发票-重新生成
export function logistics_invoice_reset(data) {
    return axios({
        url: '/admin/logistics/invoice/reset', method: 'POST', data: data
    })
}

// 物流发票-删除
export function logistics_invoice_deleted(data) {
    return axios({
        url: '/admin/logistics/invoice/deleted', method: 'POST', data: data
    })
}

// 物流地址-数据列表
export function logistics_address_lists(data) {
    return axios({
        url: '/admin/logistics/address/lists', method: 'POST', data: data
    })
}

// 物流asin-数据列表
export function logistics_asin_lists(data) {
    return axios({
        url: '/admin/logistics/asin/lists', method: 'POST', data: data
    })
}

// 运营Asin(管理员)-运营Asin列表
export function operating_asin_manager_index_operating_asin_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/operating_asin_list', method: 'POST', data: data
    })
}

// 运营Asin(管理员)--修改字段
export function operating_asin_manager_index_update_field(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/update_field', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_update_order_screenshot(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/update_order_screenshot', method: 'POST', data: data
    })
}

// 运营Asin上传(管理员)-文件列表
export function operating_asin_manager_upload_lists(data) {
    return axios({
        url: '/admin/operating_asin_manager/upload/lists', method: 'POST', data: data
    })
}

// 运营Asin(管理员)--上传
export function operating_asin_manager_upload_upload(data) {
    return axios({
        url: '/admin/operating_asin_manager/upload/upload', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_get_operating_asin_ad_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/get_operating_asin_ad_list', method: 'POST', data: data
    })
}

// 运营Asin-获取成本分析数据
export function operating_asin_manager_index_get_cost_analysis_data(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/get_cost_analysis_data', method: 'POST', data: data
    })
}

// 运营Asin-更新成本分析数据
export function operating_asin_manager_index_update_cost_analysis_data(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/update_cost_analysis_data', method: 'POST', data: data
    })
}

// 运营Asin-运营asin列表
export function operating_asin_manager_index_personal_operating_asin_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/personal_operating_asin_list', method: 'POST', data: data
    })
}

// 运营成本运费(管理员)-文件列表
export function operating_asin_manager_init_price_lists(data) {
    return axios({
        url: '/admin/operating_asin_manager/init_price/lists', method: 'POST', data: data
    })
}

// 运营成本运费(管理员)-上传
export function operating_asin_manager_init_price_upload(data) {
    return axios({
        url: '/admin/operating_asin_manager/init_price/upload', method: 'POST', data: data
    })
}

export function logistics_asin_export(data) {
    return axios({
        url: '/admin/logistics/asin/export', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_create_auto_ad(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/create_auto_ad', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_create_skag_ad(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/create_skag_ad', method: 'POST', data: data
    })
}

export function operating_asin_manager_upload_download_warn_message_excel(data) {
    return axios({
        url: '/admin/operating_asin_manager/upload/download_warn_message_excel', method: 'POST', data: data
    })
}

// 配置-分页列表
export function auth_config_index(data) {
    return axios({
        url: '/admin/auth/config/index', method: 'POST', data: data
    })
}

// 配置-新增
export function auth_config_add(data) {
    return axios({
        url: '/admin/auth/config/add', method: 'POST', data: data
    })
}

// 配置-编辑
export function auth_config_edit(data) {
    return axios({
        url: '/admin/auth/config/edit', method: 'POST', data: data
    })
}

export function cost_analysis_selfbuild_get_selection_principle(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/get_selection_principle', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_recalibrate_fba_charge(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/recalibrate_fba_charge', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_nolonger_operating_asin_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/nolonger_operating_asin_list', method: 'POST', data: data
    })
}

export function operating_asin_manager_index_personal_nolonger_operating_asin_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/personal_nolonger_operating_asin_list', method: 'POST', data: data
    })
}


// 运营包装规格（管理员）-文件列表
export function operating_asin_manager_specification_lists(data) {
    return axios({
        url: '/admin/operating_asin_manager/specification/lists', method: 'POST', data: data
    })
}

// 运营包装规格（管理员）-上传
export function operating_asin_manager_specification_upload(data) {
    return axios({
        url: '/admin/operating_asin_manager/specification/upload', method: 'POST', data: data
    })
}

// 运营asin-恢复运营中
export function operating_asin_manager_index_return_operating(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/return_operating', method: 'POST', data: data
    })
}

// teambition项目-列表
export function admin_teambition_project_lists(data) {
    return axios({
        url: '/admin/teambition/project/lists', method: 'POST', data: data
    })
}

// teambition任务-列表
export function admin_teambition_project_task_lists(data) {
    return axios({
        url: '/admin/teambition/project_task/lists', method: 'POST', data: data
    })
}

// Teambition提醒-运营人员列表
export function admin_teambition_remind_operator_lists(data) {
    return axios({
        url: '/admin/teambition/remind/operator_lists', method: 'POST', data: data
    })
}

// Teambition提醒-管理员列表
export function admin_teambition_remind_manager_lists(data) {
    return axios({
        url: '/admin/teambition/remind/manager_lists', method: 'POST', data: data
    })
}

// Teambition提醒-任务下拉列表
export function teambition_common_get_remind_content_lists(data) {
    return axios({
        url: '/admin/common/teambition_common/get_remind_content_lists', method: 'POST', data: data
    })
}

// Teambition提醒-执行人员下拉列表
export function teambition_common_get_remind_executor_lists(data) {
    return axios({
        url: '/admin/common/teambition_common/get_remind_executor_lists', method: 'POST', data: data
    })
}

// Teambition提醒-完成任务
export function admin_teambition_remind_finish_task(data) {
    return axios({
        url: '/admin/teambition/remind/finish_task', method: 'POST', data: data
    })
}

// 需要核对情况(运营)-列表
export function admin_teambition_need_verify_operator_lists(data) {
    return axios({
        url: '/admin/teambition/need_verify/operator_lists', method: 'POST', data: data
    })
}

// 需要核对情况(管理)-列表
export function admin_teambition_need_verify_manager_lists(data) {
    return axios({
        url: '/admin/teambition/need_verify/manager_lists', method: 'POST', data: data
    })
}

// 公共配置-根据 key 获取配置值
export function config_common_get_config_value_by_key(data) {
    return axios({
        url: '/admin/common/config_common/get_config_value_by_key', method: 'POST', data: data
    })
}

//
export function operating_asin_manager_index_export_operating_asin_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/index/export_operating_asin_list', method: 'POST', data: data
    })
}

//
export function cost_analysis_personal_update_patent(data) {
    return axios({
        url: '/admin/cost_analysis/personal/update_patent', method: 'POST', data: data
    })
}

// 领星店铺 - 列表
export function shoplistIndex(data) {
    return axios({
        url: '/admin/lingxing/shoplist/index', method: 'POST', data: data
    })
}

// 领星店铺 - 编辑
export function shoplistEdit(data) {
    return axios({
        url: '/admin/lingxing/shoplist/edit', method: 'POST', data: data
    })
}

// 解析中列表
export function batch_self_build_cost_analysis_updating_list(data) {
    return axios({
        url: '/admin/cost_analysis/batch_self_build/cost_analysis_updating_list', method: 'POST', data: data
    })
}

// 解析中列表 - 导入
export function batch_self_build_import(data) {
    return axios({
        url: '/admin/cost_analysis/batch_self_build/import', method: 'POST', data: data
    })
}

// 解析中列表 - 删除
export function batch_self_build_deleted(data) {
    return axios({
        url: '/admin/cost_analysis/batch_self_build/deleted', method: 'POST', data: data
    })
}

// 成本分析 - 搜索1688链接
export function selfbuild_get_ali_result(data) {
    return axios({
        url: '/admin/cost_analysis/selfbuild/get_ali_result', method: 'POST', data: data
    })
}

// 刷新价格
export function logistics_asin_fresh_price(data) {
    return axios({
        url: '/admin/logistics/asin/fresh_price', method: 'POST', data: data
    })
}

// 物流asin-批量导入
export function logistics_asin_import(data) {
    return axios({
        url: '/admin/logistics/asin/import', method: 'POST', data: data
    })
}

// 成本分析-选品忽略列表
export function cost_analysis_personal_disregarded_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_disregarded_list', method: 'POST', data: data
    })
}

// 成本分析-取消忽略
export function cost_analysis_personal_cancel_disregarded(data) {
    return axios({
        url: '/admin/cost_analysis/personal/cancel_disregarded', method: 'POST', data: data
    })
}

// 成本分析-忽略
export function cost_analysis_personal_add_to_disregarded_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/add_to_disregarded_list', method: 'POST', data: data
    })
}

// 成本分析-采购人员忽略列表
export function manager_cost_analysis_manager_disregarded_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/manager_disregarded_list', method: 'POST', data: data
    })
}

// 成本分析-选品忽略列表
export function admin_cost_analysis_personal_disregarded_list(data) {
    return axios({
        url: '/admin/cost_analysis/personal/disregarded_list', method: 'POST', data: data
    })
}

// 获取基础信息
export function ad_for_sp_base_get_sp_ad_base_message(data) {
    return axios({
        url: '/admin/ad_for_sp/base/get_sp_ad_base_message', method: 'POST', data: data
    })
}

// 设置基础信息
export function ad_for_sp_base_set_sp_ad_base_message(data) {
    return axios({
        url: '/admin/ad_for_sp/base/set_sp_ad_base_message', method: 'POST', data: data
    })
}

// 设置默认Acos
export function ad_for_sp_base_set_sp_ad_default_acos(data) {
    return axios({
        url: '/admin/ad_for_sp/base/set_sp_ad_default_acos', method: 'POST', data: data
    })
}

// 获取默认Acos
export function ad_for_sp_base_get_sp_ad_default_acos(data) {
    return axios({
        url: '/admin/ad_for_sp/base/get_sp_ad_default_acos', method: 'POST', data: data
    })
}

// sp广告-合理性分析 - 列表
export function ad_for_sp_rationality_analysis_index(data) {
    return axios({
        url: '/admin/ad_for_sp/rationality_analysis/index', method: 'POST', data: data
    })
}

// sp广告-合理性分析 - 新增
export function ad_for_sp_rationality_analysis_add(data) {
    return axios({
        url: '/admin/ad_for_sp/rationality_analysis/add', method: 'POST', data: data
    })
}

// sp广告-合理性分析 - 解析
export function ad_for_sp_rationality_analysis_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/rationality_analysis/parse', method: 'POST', data: data
    })
}

// sp广告-合理性分析 - 删除
export function ad_for_sp_rationality_analysis_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/rationality_analysis/deleted', method: 'POST', data: data
    })
}


// sp广告-运营分析 - 列表
export function ad_for_sp_operational_analysis_index(data) {
    return axios({
        url: '/admin/ad_for_sp/operational_analysis/index', method: 'POST', data: data
    })
}

// sp广告-运营分析 - 新增
export function ad_for_sp_operational_analysis_add(data) {
    return axios({
        url: '/admin/ad_for_sp/operational_analysis/add', method: 'POST', data: data
    })
}

// sp广告-运营分析 - 解析
export function ad_for_sp_operational_analysis_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/operational_analysis/parse', method: 'POST', data: data
    })
}

// sp广告-运营分析 - 删除
export function ad_for_sp_operational_analysis_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/operational_analysis/deleted', method: 'POST', data: data
    })
}

// 获取asin对应的广告组合
export function ad_for_sp_base_get_asin_portfolio_mapping(data) {
    return axios({
        url: '/admin/ad_for_sp/base/get_asin_portfolio_mapping', method: 'POST', data: data
    })
}

// Sp广告-红标表格
export function ad_for_sp_red_tag_form_index(data) {
    return axios({
        url: '/admin/ad_for_sp/red_tag_form/index', method: 'POST', data: data
    })
}

export function ad_for_sp_red_tag_form_add(data) {
    return axios({
        url: '/admin/ad_for_sp/red_tag_form/add', method: 'POST', data: data
    })
}

export function ad_for_sp_red_tag_form_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/red_tag_form/parse', method: 'POST', data: data
    })
}

export function ad_for_sp_red_tag_form_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/red_tag_form/deleted', method: 'POST', data: data
    })
}

export function asin_specification_list(data) {
    return axios({
        url: '/admin/extra/asin_specification/lists', method: 'POST', data: data
    })
}

// 列表
export function optimize_acos_excel_list_lists(data) {
    return axios({
        url: '/admin/operating_asin_manager/optimize_acos_excel_list/lists', method: 'POST', data: data
    })
}

// 列表
export function optimize_acos_excel_list_optimize_acos_detail_list(data) {
    return axios({
        url: '/admin/operating_asin_manager/optimize_acos_excel_list/optimize_acos_detail_list', method: 'POST', data: data
    })
}


// 列表
export function traffic_word_download_excel_list(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/download_excel_list', method: 'POST', data: data
    })
}


// 列表
export function traffic_word_create_excel_file(data) {
    return axios({
        url: '/admin/seed_word/traffic_word/create_excel_file', method: 'POST', data: data
    })
}


// 更新当日
export function crontab_create_operating_asin_optimize_acos(data) {
    return axios({
        url: '/callback/operating_asin_task/crontab_create_operating_asin_optimize_acos', method: 'POST', data: data
    })
}

// 删除
export function optimize_acos_excel_list_deleted(data) {
    return axios({
        url: '/admin/operating_asin_manager/optimize_acos_excel_list/deleted', method: 'POST', data: data
    })
}

// sp否定投放词映射-列表
export function negative_mapping_list(data) {
    return axios({
        url: '/admin/ad_for_sp/negative_mapping/list', method: 'post', data: data
    })
}

// sp否定投放词映射-列表
export function get_shop_lists(data) {
    return axios({
        url: '/admin/common/lingxing_common/get_shop_lists', method: 'post', data: data
    })
}

// sp否定投放词映射-列表
export function get_tfs_name_lists(data) {
    return axios({
        url: '/admin/common/teambition_common/get_tfs_name_lists', method: 'post', data: data
    })
}

// 他国创建
export function sync_create_analysis(data) {
    return axios({
        url: '/admin/cost_analysis/sync_create/analysis', method: 'post', data: data
    })
}

// 他国创建
export function sync_create_create(data) {
    return axios({
        url: '/admin/cost_analysis/sync_create/create', method: 'post', data: data
    })
}


export function operating_asin_manager_sync_create_analysis(data) {
    return axios({
        url: '/admin/operating_asin_manager/sync_create/analysis', method: 'POST', data: data
    })
}

export function operating_asin_manager_sync_create_create(data) {
    return axios({
        url: '/admin/operating_asin_manager/sync_create/create', method: 'POST', data: data
    })
}

export function low_price_mall_manager_analysis_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_analysis_list', method: 'POST', data: data
    })
}

export function low_price_mall_manager_purchase_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_purchase_list', method: 'POST', data: data
    })
}

export function low_price_mall_manager_purchase_finish_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_manager_purchase_finish_list', method: 'POST', data: data
    })
}

export function low_price_mall_commonExport(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_common/export', method: 'POST', data: data
    })
}

export function low_price_mall_cost_analysis_get_cost_analysis_card(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/get_cost_analysis_card', method: 'POST', data: data
    })
}


export function low_price_mall_developer_analysis_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_analysis_list', method: 'POST', data: data
    })
}

export function low_price_mall_developer_purchase_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_purchase_list', method: 'POST', data: data
    })
}

export function low_price_mall_developer_purchase_finish_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_developer_purchase_finish_list', method: 'POST', data: data
    })
}

// 低价商城-开发人员操作

export function low_price_mall_developer_update_patent(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/update_patent', method: 'POST', data: data
    })
}

export function low_price_mall_developer_purchase(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/purchase', method: 'POST', data: data
    })
}

export function low_price_mall_developer_return_to_analysis(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/return_to_analysis', method: 'POST', data: data
    })
}

export function low_price_mall_developer_deleted(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/deleted', method: 'POST', data: data
    })
}

export function low_price_mall_developer_finish_purchase(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/finish_purchase', method: 'POST', data: data
    })
}

export function low_price_mall_developer_return_to_purchase(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/return_to_purchase', method: 'POST', data: data
    })
}

export function low_price_mall_developer_update_cost_analysis(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_developer/update_cost_analysis', method: 'POST', data: data
    })
}

// 运营人员操作
export function low_price_mall_operator_undistributed_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/undistributed_list', method: 'POST', data: data
    })
}

export function low_price_mall_operator_wait_operation_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/wait_operation_list', method: 'POST', data: data
    })
}

export function low_price_mall_operator_operating_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/operating_list', method: 'POST', data: data
    })
}

export function low_price_mall_operator_again_add_operating_asin(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/again_add_operating_asin', method: 'POST', data: data
    })
}

export function low_price_mall_operator_no_operating_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/no_operating_list', method: 'POST', data: data
    })
}

export function low_price_mall_operator_assign_to_me(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/assign_to_me', method: 'POST', data: data
    })
}

export function low_price_mall_operator_cancel_assign(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/cancel_assign', method: 'POST', data: data
    })
}
export function low_price_mall_operator_real_operating(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/real_operating', method: 'POST', data: data
    })
}
export function low_price_mall_operator_get_operating_asin(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operator/get_operating_asin', method: 'POST', data: data
    })
}

// 实时运营
export function low_price_mall_operating_operating_asin_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/operating_asin_list', method: 'POST', data: data
    })
}

export function low_price_mall_operating_no_operating_asin_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/no_operating_asin_list', method: 'POST', data: data
    })
}

export function low_price_mall_operating_personal_operating_asin_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/personal_operating_asin_list', method: 'POST', data: data
    })
}

export function low_price_mall_operating_personal_no_operating_asin_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/personal_no_operating_asin_list', method: 'POST', data: data
    })
}

export function low_price_mall_operating_update_operating_asin(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/update_operating_asin', method: 'POST', data: data
    })
}

export function low_price_mall_operating_update_operating_asin_to_no_use(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/update_operating_asin_to_no_use', method: 'POST', data: data
    })
}

export function low_price_mall_operating_update_operating_asin_to_using(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/update_operating_asin_to_using', method: 'POST', data: data
    })
}

export function low_price_mall_operating_update_cost_analysis_details(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/update_cost_analysis_details', method: 'POST', data: data
    })
}

export function cost_analysis_export_purchase_finish_list(data) {
    return axios({
        url: '/admin/manager/cost_analysis/export_purchase_finish_list', method: 'POST', data: data
    })
}

export function low_price_mall_common_update_field(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_common/update_field', method: 'POST', data: data
    })
}

export function low_price_mall_common_update_operating_asin_field(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_common/update_operating_asin_field', method: 'POST', data: data
    })
}

export function sync_create_low_price_mall_create(data) {
    return axios({
        url: '/admin/cost_analysis/sync_create_low_price_mall/create', method: 'POST', data: data
    })
}

export function sync_create_low_price_mall_sync_create_create(data) {
    return axios({
        url: '/admin/operating_asin_manager/sync_create_low_price_mall/create', method: 'POST', data: data
    })
}




export function producer_waiting_production_list(data) {
    return axios({
        url: '/admin/link_production/producer/waiting_production_list', method: 'POST', data: data
    })
}

export function producer_personal_production_list(data) {
    return axios({
        url: '/admin/link_production/producer/personal_production_list', method: 'POST', data: data
    })
}

export function producer_personal_waiting_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/producer/personal_waiting_allocate_production_list', method: 'POST', data: data
    })
}

export function producer_personal_finish_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/producer/personal_finish_allocate_production_list', method: 'POST', data: data
    })
}

export function producer_assign_to_me(data) {
    return axios({
        url: '/admin/link_production/producer/assign_to_me', method: 'POST', data: data
    })
}

export function producer_cancel_assign(data) {
    return axios({
        url: '/admin/link_production/producer/cancel_assign', method: 'POST', data: data
    })
}

export function producer_finish_production_link(data) {
    return axios({
        url: '/admin/link_production/producer/finish_production_link', method: 'POST', data: data
    })
}

export function producer_allocate_production_link(data) {
    return axios({
        url: '/admin/link_production/producer/allocate_production_link', method: 'POST', data: data
    })
}

export function common_update_production_asins(data) {
    return axios({
        url: '/admin/link_production/common/update_production_asins', method: 'POST', data: data
    })
}




export function manager_manager_waiting_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/manager_waiting_production_list', method: 'POST', data: data
    })
}

export function manager_manager_assigned_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/manager_assigned_production_list', method: 'POST', data: data
    })
}

export function manager_manager_waiting_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/manager_waiting_allocate_production_list', method: 'POST', data: data
    })
}

export function manager_manager_finish_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/manager_finish_allocate_production_list', method: 'POST', data: data
    })
}

export function manager_manager_assign_producer(data) {
    return axios({
        url: '/admin/link_production/manager/manager_assign_producer', method: 'POST', data: data
    })
}

export function manager_manager_cancel_assign(data) {
    return axios({
        url: '/admin/link_production/manager/manager_cancel_assign', method: 'POST', data: data
    })
}
export function common_get_producer_list(data) {
    return axios({
        url: '/admin/link_production/common/get_producer_list', method: 'POST', data: data
    })
}
export function asin_list_get_teambition_task_list(data) {
    return axios({
        url: '/admin/seed_word/asin_list/get_teambition_task_list', method: 'POST', data: data
    })
}
export function low_price_mall_operating_update_field(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/update_field', method: 'POST', data: data
    })
}
export function low_price_mall_operating_get_ad_lists(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_operating/get_ad_lists', method: 'POST', data: data
    })
}

export function low_price_mall_cost_analysis_low_price_mall_disregarded_list(data) {
    return axios({
        url: '/admin/low_price_mall/low_price_mall_cost_analysis/low_price_mall_disregarded_list', method: 'POST', data: data
    })
}

export function project_budget_index(data) {
    return axios({
        url: '/admin/ad_for_sp/project_budget/index', method: 'POST', data: data
    })
}
export function project_budget_add(data) {
    return axios({
        url: '/admin/ad_for_sp/project_budget/add', method: 'POST', data: data
    })
}
export function project_budget_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/project_budget/parse', method: 'POST', data: data
    })
}
export function project_budget_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/project_budget/deleted', method: 'POST', data: data
    })
}
export function competing_asin_attribute_lists(data) {
    return axios({
        url: '/admin/extra/competing_asin_attribute/lists', method: 'POST', data: data
    })
}

export function statistics_statistics_kpi_teambition_category(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_kpi_teambition_category', method: 'POST', data: data
    })
}

export function export_statistics_kpi_teambition_category(data) {
    return axios({
        url: '/admin/manager/statistics/export_statistics_kpi_teambition_category', method: 'POST', data: data
    })
}

export function statistics_statistics_kpi_teambition_operator(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_kpi_teambition_operator', method: 'POST', data: data
    })
}
export function statistics_statistics_operator_sales_volume(data) {
    return axios({
        url: '/admin/manager/statistics/statistics_operator_sales_volume', method: 'POST', data: data
    })
}

export function asin_traffic_comparison_index(data) {
    return axios({
        url: '/admin/extra/asin_traffic_comparison/index', method: 'POST', data: data
    })
}

export function asin_traffic_comparison_add(data) {
    return axios({
        url: '/admin/extra/asin_traffic_comparison/add', method: 'POST', data: data
    })
}

export function asin_traffic_comparison_parsing_file(data) {
    return axios({
        url: '/admin/extra/asin_traffic_comparison/parsing_file', method: 'POST', data: data
    })
}

export function ad_for_sp_transfer_index(data) {
    return axios({
        url: '/admin/ad_for_sp/transfer/index', method: 'POST', data: data
    })
}
export function ad_for_sp_transfer_add(data) {
    return axios({
        url: '/admin/ad_for_sp/transfer/add', method: 'POST', data: data
    })
}
export function ad_for_sp_transfer_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/transfer/parse', method: 'POST', data: data
    })
}
export function ad_for_sp_transfer_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/transfer/deleted', method: 'POST', data: data
    })
}

// 数据清洗 - 列表
export function ad_for_sp_data_clean_index(data) {
    return axios({
        url: '/admin/ad_for_sp/data_clean/index', method: 'POST', data: data
    })
}
// 数据清洗 - 添加
export function ad_for_sp_data_clean_add(data) {
    return axios({
        url: '/admin/ad_for_sp/data_clean/add', method: 'POST', data: data
    })
}
// 数据清洗 - 解析
export function ad_for_sp_data_clean_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/data_clean/parse', method: 'POST', data: data
    })
}
// 数据清洗 - 删除
export function ad_for_sp_data_clean_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/data_clean/deleted', method: 'POST', data: data
    })
}

// 数据趋势 - 列表
export function ad_for_sp_data_trend_index(data) {
    return axios({
        url: '/admin/ad_for_sp/data_trend/index', method: 'POST', data: data
    })
}

// 数据趋势 - 添加
export function ad_for_sp_data_trend_add(data) {
    return axios({
        url: '/admin/ad_for_sp/data_trend/add', method: 'POST', data: data
    })
}

// 数据趋势 - 解析
export function ad_for_sp_data_trend_parse(data) {
    return axios({
        url: '/admin/ad_for_sp/data_trend/parse', method: 'POST', data: data
    })
}

// 数据趋势 - 删除
export function ad_for_sp_data_trend_deleted(data) {
    return axios({
        url: '/admin/ad_for_sp/data_trend/deleted', method: 'POST', data: data
    })
}

export function crontab_refresh_waiting_allocate_asin_sale_count(data) {
    return axios({
        url: '/callback/task/crontab_refresh_waiting_allocate_asin_sale_count', method: 'POST', data: data
    })
}

export function manager_export_manager_waiting_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/export_manager_waiting_allocate_production_list', method: 'POST', data: data
    })
}

export function manager_export_manager_finish_allocate_production_list(data) {
    return axios({
        url: '/admin/link_production/manager/export_manager_finish_allocate_production_list', method: 'POST', data: data
    })
}
